import { createAction, props } from '@ngrx/store';

import {
  Institution,
  InstitutionsForOccupationOptions,
  SchoolDetails
} from '@cpd-app/core-module/models';
import { QueryInstitutionsByProgramArgs } from '@cpd-app/generated';

export const loadInstitutions = createAction(
  '[Institution/API] Load Institutions'
);

export const institutionsLoadedSuccess = createAction(
  '[Institution/API] Institutions Loaded Success',
  // OC-2. totalCount is the whole matched set, not institutions.length, which
  // is one page of it.
  props<{ institutions: Institution[]; totalCount: number }>()
);

/** OC-2. Move to a page of the current result set, keeping every filter. */
export const setInstitutionsPage = createAction(
  '[Institution/Page] Set Institutions Page',
  props<{ offset: number }>()
);

export const institutionsLoadedFailure = createAction(
  '[Institution/API] Institutions Loaded Failure',
  props<{ error: any }>()
);

export const clearInstitutions = createAction(
  '[Institution/API] Clear Institutions'
);

export const updateInstitutionsForOccupationOptions = createAction(
  '[Institution/API] Update Institutions For Occupation Options',
  props<{ options: Partial<InstitutionsForOccupationOptions> }>()
);

export const clearInstitutionsForOccupationOptions = createAction(
  '[Institution/API] Clear Update Institutions For Occupation Options'
);

export const setSelectedInstitution = createAction(
  '[Institution/API] Set Selected Institution',
  props<{ institutionId: string }>()
);

export const institutionDetailsLoadedSuccess = createAction(
  '[Institution/API] Institution Details Loaded Success',
  props<{ institutionDetails: SchoolDetails }>()
);

export const institutionDetailsLoadedFailure = createAction(
  '[Institution/API] Institution Details Loaded Failure',
  props<{ error: any }>()
);

export const loadInstitutionsByProgram = createAction(
  '[Institution/API] Load Institutions By Program',
  props<{ input: Partial<QueryInstitutionsByProgramArgs> }>()
);

export const loadInstitutionsByProgramSuccess = createAction(
  '[Institution/API] Load Institutions By Program Success',
  props<{ institutions: Institution[] }>()
);

export const loadInstitutionsByProgramFailure = createAction(
  '[Institution/API] Load Institutions By Program Failure',
  props<{ error: any }>()
);
